import { useMediaQuery } from "react-responsive";

const Component = () => {
  const spa = useMediaQuery({ query: "(min-width: 992px)" });

  document.body.className = spa ? "spa" : "pwa";

  return <></>;
};

export default Component;
